<div class="container-welcome" fxLayout="row">
  <div class="left"></div>
  <div class="middle">
    <h1>Uitnodiging afgerond</h1>
    <p>
      De uitnodiging is succesvol afgerond, u kunt nu uw browser sluiten en inloggen in de client software van DIAS Advies Cloud.
    </p>
  </div>
  <div class="right"></div>
</div>